(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("map-add-remove-layers", [], factory);
	else if(typeof exports === 'object')
		exports["map-add-remove-layers"] = factory();
	else
		root["map-add-remove-layers"] = factory();
})(self, function() {
return 